import axios from 'axios';
import Swiper from 'swiper';

export default function ajaxKeywords() {
    let searchTimeout, nofocusTimeout;
    let hasChanged = false;
    let hasResult = false;
    const SECONDE = 1000;
    const keywordsResult = document.querySelector('[data-keywords-result]');
    const submitBtn = document.querySelector('.search__btn');
    const activeKeywordsClass = 'search-results-keywords--active';
    let inputSearch = document.getElementById('customSearch')



    inputSearch?.addEventListener('focusout', function(){
        hasChanged = false;
        nofocusTimeout = setTimeout(function() {
            keywordsResult.classList.remove(activeKeywordsClass);
        },  SECONDE );
    });

    inputSearch?.addEventListener('focus', function(){
        clearTimeout(nofocusTimeout);
        if (!hasChanged && hasResult) {
            keywordsResult.classList.add(activeKeywordsClass);
        }
    });
    inputSearch?.addEventListener('input', function() {
        hasChanged = true;
    });
    inputSearch?.addEventListener('keyup', function () {
        const searchTerm = this.value;
        hasResult = false;

        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        searchTimeout = setTimeout(function () {
            if (searchTerm.length > 2) {
                let formData = new FormData();
                formData.append('action', 'keyword_search');
                formData.append('term', searchTerm);
                axios.post('/wp-admin/admin-ajax.php', formData)
                    .then(function (response) {
                        if(!keywordsResult) return;
                        keywordsResult.innerHTML = response.data;
                        if(response.data){
                            hasResult = true;
                            keywordsResult.classList.add(activeKeywordsClass);
                            executeKeyword();
                        }
                    })
                    .catch(function (error) {
                        console.log('Erreur Axios : ', error);
                    });
            }
            else{
                keywordsResult.classList.remove(activeKeywordsClass);
            }
        }, SECONDE);
    });

    function executeKeyword(){
        const keywords = document.querySelectorAll('[data-keyword]');
        if(keywords){
            keywords.forEach(keyword =>{
                keyword.addEventListener('click', function(e){
                    inputSearch.value = keyword.getAttribute('data-keyword');
                    submitBtn.click();
                })
            })
        }
    }
}